import { Component, OnDestroy } from '@angular/core';
import { trackByRef } from 'src/app/lego-utils';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Subscription } from 'rxjs';
import { CreateQuickUrlDrawerComponent } from 'src/app/components/main-content/admin/manage-quick-urls/create-quick-url-drawer/create-quick-url-drawer.component';
import { EditQuickUrlDrawerComponent } from 'src/app/components/main-content/admin/manage-quick-urls/edit-quick-url-drawer/edit-quick-url-drawer.component';
import { IQuickUrl, QuickUrlService } from 'src/app/state';

@Component({
  selector: 'em-add-quick-url',
  styleUrls: ['./manage-quick-urls.component.less'],
  templateUrl: './manage-quick-urls.component.html',
  standalone: false,
})
export class ManageQuickUrlsComponent implements OnDestroy {
  public urls$ = this.quickUrlService.quickUrls$;
  public error$ = this.quickUrlService.error$;
  public isLoading$ = this.quickUrlService.loading$;
  public displayData?: IQuickUrl[];
  public readonly trackByRef = trackByRef;
  public deleteLoading?: string;

  private readonly subscription = new Subscription();

  public constructor(
    private readonly quickUrlService: QuickUrlService,
    private readonly drawerService: NzDrawerService,
    private readonly messageService: NzMessageService
  ) {}

  public deleteQuickUrl(shortName: string) {
    this.deleteLoading = shortName;

    this.subscription.add(
      this.quickUrlService.delete(shortName).subscribe({
        next: () => {
          this.deleteLoading = undefined;
        },
        error: (error: unknown) => {
          const errorMessage = error instanceof Error ? error.message : String(error);
          this.messageService.error(errorMessage);
          this.deleteLoading = undefined;
        },
      })
    );
  }

  public createQuickUrl() {
    this.drawerService.create({
      nzContent: CreateQuickUrlDrawerComponent,
      nzTitle: 'Create new quick url',
      nzWidth: 520,
    });
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public editQuickUrl(url: IQuickUrl) {
    this.drawerService.create({
      nzContent: EditQuickUrlDrawerComponent,
      nzContentParams: url,
      nzTitle: 'Edit quick url',
      nzWidth: 520,
    });
  }
}
